import styled, { css } from 'styled-components';

export interface DivProps {
  $isChecked: boolean;
  $disabled?: boolean;
  $invisibleWhenHidden?: boolean;
  $small?: boolean;
  $medium?: boolean;
}

export const Div = styled.div<DivProps>`
  width: 25px;
  min-width: 25px;
  height: 25px;
  cursor: pointer;
  border-radius: 3px;
  border: 2px solid ${({ theme }) => theme.colors.gp2};
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    color: ${({ theme }) => theme.colors.white};
    font-size: 16px;
  }

  ${({ $isChecked }) =>
    $isChecked &&
    css`
      border: none;
      background: ${({ theme }) => theme.colors.gradient};
    `};

  ${({ $disabled, $invisibleWhenHidden, $isChecked, theme }) =>
    $disabled &&
    css`
      pointer-events: none;
      border: none;
      opacity: ${$invisibleWhenHidden ? 0 : 1};
      border: 2px solid ${theme.colors.cflowerBlue};
      background: ${$isChecked ? theme.colors.cflowerBlue : 'transparent'};
    `};

  ${({ $medium }) =>
    $medium &&
    css`
      width: 23px;
      min-width: 23px;
      height: 23px;
    `}

  ${({ $small }) =>
    $small &&
    css`
      width: 20px;
      min-width: 20px;
      height: 20px;
    `};

  ${({ theme }) => theme.breakpoints.down('sm')} {
    width: 23px;
    min-width: 23px;
    height: 23px;
    ${({ $medium }) =>
      $medium &&
      css`
        width: 20px;
        min-width: 20px;
        height: 20px;
      `}

    ${({ $small }) =>
      $small &&
      css`
        width: 17px;
        min-width: 17px;
        height: 17px;
      `};
  }
`;
